function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 3");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-284.000000, -38.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(223.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#EE1D24",
  cx: 26,
  cy: 26,
  r: 26
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.000000, 18.000000)",
  fill: "#FAFAFA",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.01280279,0 C1.91763122,0.00145844255 1.82743785,0.0391000712 1.76067375,0.106573111 L0.10653484,1.76070804 C-0.0355116134,1.90275415 -0.0355116134,2.13287339 0.10653484,2.27491041 L5.8323933,7.99857326 L0.10653484,13.7244179 L0.10653484,13.7251281 C-0.0355116134,13.8671742 -0.0355116134,14.0972935 0.10653484,14.2393305 L1.76067375,15.8934654 C1.9027202,16.0355115 2.13284,16.0355115 2.27487737,15.8934654 L7.99855399,10.1676207 L13.7244124,15.8934654 L13.7251226,15.8934654 C13.8671691,16.0355115 14.0972889,16.0355115 14.2393263,15.8934654 L15.8934652,14.2393305 C16.0355116,14.0972844 16.0355116,13.8671651 15.8934652,13.7251281 L10.1676067,7.99928344 L15.8934652,2.2756206 L15.8934652,2.27491041 C16.0355116,2.1328643 16.0355116,1.90274506 15.8934652,1.76070804 L14.2393263,0.106573111 C14.0972798,-0.035473001 13.86716,-0.035473001 13.7251226,0.106573111 L7.99926418,5.83241778 L2.27558755,0.106573111 L2.27487737,0.106573111 C2.20527506,0.0369709705 2.11081439,-0.00138193422 2.01280279,0 Z"
}))))));

var SvgRespondUnavailable = function SvgRespondUnavailable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRespondUnavailable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/respond_unavailable.77e39ce6.svg";
export { ForwardRef as ReactComponent };